import { StoreAsset } from '~/constants/stores';
import { StoreConnectActionKeys, StoreConnectActionTypes } from './store-connect.actions';

export const StoreConnectAPIErrors = {
  STORE_ALREADY_CONNECTED_ERROR: (store: string) => `You already have a ${store} store connected`,
  MISSING_USERID_ERROR: () => 'User ID is missing.',
  INVALID_JWT_HEADER: () => 'Please login and try again.',
  POSSIBLE_CREDENTIALS_ERROR: (store: string) =>
    `Could not connect your ${store} store. Are your credentials correct ?`,
  MISSING_SCOPES_ERROR: (store: string) =>
    `Could not connect your ${store} store. Missing permissions in your delegated access key.`,
  CATCH_ALL: (store: string) => `Could not connect your ${store} store.`,
};

export interface StoreConnectState {
  error?: string | null;
  loading: boolean;
  storeSelection: StoreAsset | null;
  shippoLocation: string;
  redirectUrl: string;
  readyForUrl: boolean;
}

const initialState: StoreConnectState = {
  error: null,
  loading: false,
  storeSelection: null,
  shippoLocation: '',
  redirectUrl: '',
  readyForUrl: false,
};

function reducer(
  state: StoreConnectState = initialState,
  action: StoreConnectActionTypes,
): StoreConnectState {
  switch (action.type) {
    case StoreConnectActionKeys.START_STORE_CONNECT:
      return {
        ...state,
        storeSelection: action.payload.storeSelection,
        shippoLocation: action.payload.shippoLocation,
        readyForUrl: action.payload.readyForUrl,
        error: null,
      };
    case StoreConnectActionKeys.STORE_CONNECT_URL_FETCH:
      return {
        ...state,
        loading: true,
      };
    case StoreConnectActionKeys.STORE_CONNECT_URL_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        redirectUrl: action.payload.redirectUrl,
        readyForUrl: false,
      };
    case StoreConnectActionKeys.STORE_CONNECT_URL_FETCH_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        readyForUrl: false,
      };
    case StoreConnectActionKeys.STORE_CONNECT_DISMISS_ERROR:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
}

export default reducer;
